// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: white;
  height: 100vh;
}

ion-title {
  padding: 0 !important;
}

.product {
  --inner-padding-top: 16px;
  --inner-padding-bottom: 16px;
}
.product .space-top {
  margin-top: 6px;
  font-size: 13px !important;
}
.product::part(native) {
  align-items: flex-start;
}
.product .quantity {
  margin-top: 16px;
}
.product .quantity p {
  color: var(--ion-color-primary);
  font-weight: 600;
}
.product ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: var(--ion-color-medium);
}
.product ul li {
  font-size: 14px !important;
  margin-top: 4px;
}
.product ul li p,
.product ul li span,
.product ul li div {
  font-size: 14px !important;
}

.sub-product {
  --inner-padding-top: 8px !important;
  --inner-padding-bottom: 8px !important;
}
.sub-product .quantity {
  margin-top: 8px !important;
}

.print-btn {
  --background: rgb(1 106 255 / 9%);
  --background-hover: rgb(1 106 255 / 9%);
  --background-activated: rgb(1 106 255 / 9%);
  color: var(--ion-color-primary);
  --color: var(--ion-color-primary);
}

ion-list {
  overflow-y: auto;
  flex-grow: 1;
}
ion-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: var(--ion-color-primary);
}
ion-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footer {
  border-top: 1px solid #efefef;
  padding-bottom: env(safe-area-inset-bottom) !important;
}
.footer ion-item {
  --padding-top: 8px !important;
  --padding-bottom: 8px !important;
}

.btn-options {
  --padding-top: 2px;
  --padding-bottom: 2px;
  --background: #ecf3ff;
  --color: var(--ion-color-primary);
  width: 100%;
}
.btn-options ion-icon {
  font-size: 18px;
  color: var(--ion-color-primary);
}
.btn-options ion-text {
  font-weight: 600;
}

.bottom-data .total ion-label {
  font-size: 19px !important;
  font-weight: 600;
  margin: 0;
  padding: 0;
}
.bottom-data .total p {
  font-size: 19px;
  font-weight: 600;
  color: var(--ion-color-dark);
}

.buttons {
  padding: 16px;
  padding-top: 0;
}
.buttons ion-button {
  font-size: 16px;
}
.buttons ion-button ion-icon {
  font-size: 17px !important;
}
.buttons .flex {
  gap: 10px !important;
}

.drinks {
  border-left: 3px solid var(--ion-color-primary);
}

.entree {
  border-left: 3px solid var(--ion-color-warning);
}

.main {
  border-left: 3px solid var(--ion-color-success);
}

.dessert {
  border-left: 3px solid var(--ion-color-tertiary);
}

ion-item {
  --inner-padding-end: 16px;
}

.thread {
  background: var(--ion-color-primary);
  border-bottom-color: var(--ion-color-primary);
}

.item-promotion {
  --padding-start: 0;
  --inner-padding-start: 0;
  --inner-padding-end: 0;
}
.item-promotion .promo-container {
  width: 100%;
}

@media (max-width: 767px) {
  .buttons {
    padding-bottom: 0 !important;
  }
}
.notes ion-icon {
  font-size: 18px;
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pos/ticket/ticket.component.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,aAAA;AACD;;AAEA;EACC,qBAAA;AACD;;AAEA;EACC,yBAAA;EACA,4BAAA;AACD;AACC;EACC,eAAA;EACA,0BAAA;AACF;AAEC;EACC,uBAAA;AAAF;AAGC;EACC,gBAAA;AADF;AAGE;EACC,+BAAA;EACA,gBAAA;AADH;AAKC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;AAHF;AAKE;EACC,0BAAA;EACA,eAAA;AAHH;AAKG;;;EAGC,0BAAA;AAHJ;;AASA;EACC,mCAAA;EACA,sCAAA;AAND;AAQC;EACC,0BAAA;AANF;;AAkBA;EACC,iCAAA;EACA,uCAAA;EACA,2CAAA;EACA,+BAAA;EACA,iCAAA;AAfD;;AAkBA;EACC,gBAAA;EACA,YAAA;AAfD;AAiBC;EACC,mBAAA;EACA,oDAAA;EACA,0CAAA;AAfF;AAkBC;EACC,oDAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAoBA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAjBD;;AAoBA;EACC,6BAAA;EACA,sDAAA;AAjBD;AAmBC;EACC,6BAAA;EACA,gCAAA;AAjBF;;AAqBA;EACC,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iCAAA;EACA,WAAA;AAlBD;AAoBC;EACC,eAAA;EACA,+BAAA;AAlBF;AAqBC;EACC,gBAAA;AAnBF;;AAyBE;EACC,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAtBH;AAyBE;EACC,eAAA;EACA,gBAAA;EACA,4BAAA;AAvBH;;AA4BA;EACC,aAAA;EACA,cAAA;AAzBD;AA2BC;EACC,eAAA;AAzBF;AA2BE;EACC,0BAAA;AAzBH;AA6BC;EACC,oBAAA;AA3BF;;AA+BA;EACC,+CAAA;AA5BD;;AA+BA;EACC,+CAAA;AA5BD;;AA+BA;EACC,+CAAA;AA5BD;;AA+BA;EACC,gDAAA;AA5BD;;AA+BA;EACC,yBAAA;AA5BD;;AA+BA;EACC,oCAAA;EACA,6CAAA;AA5BD;;AA+BA;EACC,kBAAA;EACA,wBAAA;EACA,sBAAA;AA5BD;AA8BC;EACC,WAAA;AA5BF;;AAiCA;EACC;IACC,4BAAA;EA9BA;AACF;AAkCC;EACC,eAAA;EACA,iBAAA;AAhCF","sourcesContent":["ion-content {\n\t--background: white;\n\theight: 100vh;\n}\n\nion-title {\n\tpadding: 0 !important;\n}\n\n.product {\n\t--inner-padding-top: 16px;\n\t--inner-padding-bottom: 16px;\n\n\t.space-top {\n\t\tmargin-top: 6px;\n\t\tfont-size: 13px !important;\n\t}\n\n\t&::part(native) {\n\t\talign-items: flex-start;\n\t}\n\n\t.quantity {\n\t\tmargin-top: 16px;\n\n\t\tp {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tcolor: var(--ion-color-medium);\n\n\t\tli {\n\t\t\tfont-size: 14px !important;\n\t\t\tmargin-top: 4px;\n\n\t\t\tp,\n\t\t\tspan,\n\t\t\tdiv {\n\t\t\t\tfont-size: 14px !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.sub-product {\n\t--inner-padding-top: 8px !important;\n\t--inner-padding-bottom: 8px !important;\n\n\t.quantity {\n\t\tmargin-top: 8px !important;\n\t}\n}\n\n// .order-item {\n// \t--background: #edf0f3 !important;\n\n// \tbutton {\n// \t\tbackground-color: #edf0f3 !important;\n// \t}\n// }\n\n.print-btn {\n\t--background: rgb(1 106 255 / 9%);\n\t--background-hover: rgb(1 106 255 / 9%);\n\t--background-activated: rgb(1 106 255 / 9%);\n\tcolor: var(--ion-color-primary);\n\t--color: var(--ion-color-primary);\n}\n\nion-list {\n\toverflow-y: auto;\n\tflex-grow: 1;\n\n\t&::-webkit-scrollbar-thumb {\n\t\tborder-radius: 10px;\n\t\t-webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);\n\t\tbackground-color: var(--ion-color-primary);\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\t-webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);\n\t\tborder-radius: 10px;\n\t\tbackground-color: #f5f5f5;\n\t}\n}\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.footer {\n\tborder-top: 1px solid #efefef;\n\tpadding-bottom: env(safe-area-inset-bottom) !important;\n\n\tion-item {\n\t\t--padding-top: 8px !important;\n\t\t--padding-bottom: 8px !important;\n\t}\n}\n\n.btn-options {\n\t--padding-top: 2px;\n\t--padding-bottom: 2px;\n\t--background: #ecf3ff;\n\t--color: var(--ion-color-primary);\n\twidth: 100%;\n\n\tion-icon {\n\t\tfont-size: 18px;\n\t\tcolor: var(--ion-color-primary);\n\t}\n\n\tion-text {\n\t\tfont-weight: 600;\n\t}\n}\n\n.bottom-data {\n\t.total {\n\t\tion-label {\n\t\t\tfont-size: 19px !important;\n\t\t\tfont-weight: 600;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 19px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: var(--ion-color-dark);\n\t\t}\n\t}\n}\n\n.buttons {\n\tpadding: 16px;\n\tpadding-top: 0;\n\n\tion-button {\n\t\tfont-size: 16px;\n\n\t\tion-icon {\n\t\t\tfont-size: 17px !important;\n\t\t}\n\t}\n\n\t.flex {\n\t\tgap: 10px !important;\n\t}\n}\n\n.drinks {\n\tborder-left: 3px solid var(--ion-color-primary);\n}\n\n.entree {\n\tborder-left: 3px solid var(--ion-color-warning);\n}\n\n.main {\n\tborder-left: 3px solid var(--ion-color-success);\n}\n\n.dessert {\n\tborder-left: 3px solid var(--ion-color-tertiary);\n}\n\nion-item {\n\t--inner-padding-end: 16px;\n}\n\n.thread {\n\tbackground: var(--ion-color-primary);\n\tborder-bottom-color: var(--ion-color-primary);\n}\n\n.item-promotion {\n\t--padding-start: 0;\n\t--inner-padding-start: 0;\n\t--inner-padding-end: 0;\n\n\t.promo-container {\n\t\twidth: 100%;\n\t}\n}\n\n\n@media (max-width: 767px) {\n\t.buttons {\n\t\tpadding-bottom: 0 !important;\n\t}\n}\n\n.notes {\n\tion-icon {\n\t\tfont-size: 18px;\n\t\tmargin-right: 8px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
